import Color from "color";

const map = new Map<string, boolean>();

export function isDarkColor(color: string) {
  const isDark = map.get(color);
  if (isDark !== undefined) {
    return isDark;
  }

  const setDark = Color(color).darken(0.35).isDark();
  map.set(color, setDark);
  return setDark;
}
